import IconButton from 'components/Kizen/IconButton';
import Icon from 'components/Kizen/Icon';
import { useTranslation } from 'react-i18next';

const closeButtonColor = {
  default: 'var(--color-background-dark)',
  hover: 'var(--color-background-darker)',
};

const CloseButton = (props) => {
  const { t } = useTranslation();
  return (
    <IconButton
      title={t('Close')}
      sizing="mobile"
      data-dismiss="modal"
      color={closeButtonColor}
      {...props}
    >
      <Icon icon="close-cross" />
    </IconButton>
  );
};

export default CloseButton;
